"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _Transition = _interopRequireWildcard(require("./Transition"));

var _PopoverTriggerWrapper = _interopRequireDefault(require("./PopoverTriggerWrapper"));

var _constants = require("./constants");

var _sharedPropTypes = require("./sharedPropTypes");

var _renderPopover = require("./renderPopover");

var _core = require("@emotion/core");

// Listen to changes and update the position and alignment
var useAutoReposition = function useAutoReposition(_ref) {
  var setPosition = _ref.setPosition,
      setAlignment = _ref.setAlignment,
      shouldAutoReposition = _ref.shouldAutoReposition;
  var removePositionObserver = (0, _react.useRef)();
  var hasRepositioned = (0, _react.useRef)(false);

  var handleIntersection = function handleIntersection(entries) {
    var entry = entries[0]; // If it's fully visible, return

    if (entry.intersectionRatio === 1) {
      return;
    }

    if (hasRepositioned.current) {
      return;
    }

    var _entry$boundingClient = entry.boundingClientRect,
        top = _entry$boundingClient.top,
        right = _entry$boundingClient.right,
        bottom = _entry$boundingClient.bottom,
        left = _entry$boundingClient.left;
    var html = document.documentElement;
    var windowWidth = window.innerWidth || html.clientWidth;
    var windowHeight = window.innerHeight || html.clientHeight;

    if (Math.floor(top) < 0) {
      setPosition(_constants.POPOVER_POSITION.BOTTOM);
      hasRepositioned.current = true;
    } else if (Math.ceil(bottom) > windowHeight) {
      setPosition(_constants.POPOVER_POSITION.TOP);
      hasRepositioned.current = true;
    }

    if (Math.floor(left) < 0) {
      setAlignment(_constants.POPOVER_ALIGNMENT.LEFT);
      hasRepositioned.current = true;
    } else if (Math.ceil(right) > windowWidth) {
      setAlignment(_constants.POPOVER_ALIGNMENT.RIGHT);
      hasRepositioned.current = true;
    }
  }; // Listen to changes once the ref is set


  var setPopoverRef = (0, _react.useCallback)(function (element) {
    if (!window.IntersectionObserver || !shouldAutoReposition) {
      return;
    } // Before adding an observer, clean any previous ones


    if (removePositionObserver.current) {
      removePositionObserver.current();
      removePositionObserver.current = undefined;
    } // If the component has unmounted, return


    if (!element) {
      return;
    }

    var observer = new window.IntersectionObserver(handleIntersection, {
      threshold: 1
    });
    observer.observe(element);

    removePositionObserver.current = function () {
      return observer.unobserve(element);
    };
  }, [shouldAutoReposition, removePositionObserver.current]);
  return {
    setPopoverRef: setPopoverRef
  };
}; // Instantiate and update position and alignment props


var usePositionAndAlignment = function usePositionAndAlignment(_ref2) {
  var popoverPosition = _ref2.popoverPosition,
      popoverAlignment = _ref2.popoverAlignment,
      shouldAutoReposition = _ref2.shouldAutoReposition;

  var _useState = (0, _react.useState)(popoverPosition),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = (0, _react.useState)(popoverAlignment),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      alignment = _useState4[0],
      setAlignment = _useState4[1]; // Update popoverPosition if prop changes


  (0, _react.useEffect)(function () {
    setPosition(popoverPosition);
  }, [popoverPosition]); // Update popoverAlignment if prop changes

  (0, _react.useEffect)(function () {
    setAlignment(popoverAlignment);
  }, [popoverAlignment]); // Reposition if the component moves

  var _useAutoReposition = useAutoReposition({
    setPosition: setPosition,
    setAlignment: setAlignment,
    shouldAutoReposition: shouldAutoReposition
  }),
      setPopoverRef = _useAutoReposition.setPopoverRef;

  return {
    position: position,
    alignment: alignment,
    setPopoverRef: setPopoverRef
  };
};

var WithPopoverDefaultProps = {
  popoverPosition: _constants.POPOVER_POSITION.BOTTOM,
  popoverAlignment: _constants.POPOVER_ALIGNMENT.LEFT,
  shouldAutoReposition: true,
  shouldCloseOnFocusLeave: true,
  shouldFocusTriggerOnClose: true,
  buttonPopover: false,
  'aria-haspopup': 'dialog'
};

var WithPopover = function WithPopover(_ref3) {
  var shouldFocusTriggerOnClose = _ref3.shouldFocusTriggerOnClose,
      triggerVerticalAlign = _ref3.triggerVerticalAlign,
      children = _ref3.children,
      shouldCloseOnFocusLeave = _ref3.shouldCloseOnFocusLeave,
      _ref3$popoverPosition = _ref3.popoverPosition,
      popoverPosition = _ref3$popoverPosition === void 0 ? WithPopoverDefaultProps.popoverPosition : _ref3$popoverPosition,
      _ref3$popoverAlignmen = _ref3.popoverAlignment,
      popoverAlignment = _ref3$popoverAlignmen === void 0 ? WithPopoverDefaultProps.popoverAlignment : _ref3$popoverAlignmen,
      _ref3$shouldAutoRepos = _ref3.shouldAutoReposition,
      shouldAutoReposition = _ref3$shouldAutoRepos === void 0 ? WithPopoverDefaultProps.shouldAutoReposition : _ref3$shouldAutoRepos,
      popoverWidth = _ref3.popoverWidth,
      popoverMaxWidth = _ref3.popoverMaxWidth,
      renderPopoverContent = _ref3.renderPopoverContent,
      padding = _ref3.padding,
      buttonPopover = _ref3.buttonPopover,
      _ref3$ariaHaspopup = _ref3['aria-haspopup'],
      ariaHasPopup = _ref3$ariaHaspopup === void 0 ? WithPopoverDefaultProps['aria-haspopup'] : _ref3$ariaHaspopup;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isOpen = _useState6[0],
      setOpen = _useState6[1];

  var prevActiveEl = (0, _react.useRef)();

  var _usePositionAndAlignm = usePositionAndAlignment({
    popoverPosition: popoverPosition,
    popoverAlignment: popoverAlignment,
    shouldAutoReposition: shouldAutoReposition
  }),
      position = _usePositionAndAlignm.position,
      alignment = _usePositionAndAlignm.alignment,
      setPopoverRef = _usePositionAndAlignm.setPopoverRef;

  var open = function open() {
    prevActiveEl.current = shouldFocusTriggerOnClose ? document.activeElement || undefined : undefined;
    setOpen(true);
  };

  var close = function close() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$focusTriggerOnC = _ref4.focusTriggerOnClose,
        focusTriggerOnClose = _ref4$focusTriggerOnC === void 0 ? false : _ref4$focusTriggerOnC;

    focusTriggerOnClose && shouldFocusTriggerOnClose && prevActiveEl.current && prevActiveEl.current.focus && prevActiveEl.current.focus();
    setOpen(false);
    prevActiveEl.current = undefined;
  };

  var closeAndFocusTrigger = function closeAndFocusTrigger() {
    return close({
      focusTriggerOnClose: true
    });
  };

  var toggle = function toggle() {
    isOpen ? closeAndFocusTrigger() : open();
  };

  var handleFocusLeave = function handleFocusLeave() {
    shouldCloseOnFocusLeave && close();
  };

  return (0, _core.jsx)(_PopoverTriggerWrapper.default, {
    onFocusLeave: handleFocusLeave,
    verticalAlign: triggerVerticalAlign
  }, children({
    isOpen: isOpen,
    open: open,
    close: closeAndFocusTrigger,
    toggle: toggle,
    'aria-haspopup': ariaHasPopup
  }), (0, _core.jsx)(_Transition.default, {
    hide: !isOpen,
    transitionTime: 0.2
  }, function (_ref5) {
    var animState = _ref5.animState,
        transitionTime = _ref5.transitionTime;
    return (0, _renderPopover.renderPopover)({
      isOpen: animState !== _Transition.BEFORE_ENTER && isOpen,
      popoverPosition: position,
      popoverAlignment: alignment,
      popoverWidth: popoverWidth,
      popoverMaxWidth: popoverMaxWidth,
      transitionTime: transitionTime,
      renderPopoverContent: renderPopoverContent,
      padding: padding,
      buttonPopover: buttonPopover,
      close: closeAndFocusTrigger,
      setPopoverRef: setPopoverRef,
      'aria-haspopup': ariaHasPopup
    });
  }));
};

WithPopover.displayName = 'WithPopover';
WithPopover.defaultProps = WithPopoverDefaultProps;
var WithPopoverWithDocs = (0, _stencilReactDesc.describe)(WithPopover).description('FAC component for displaying popovers.');
WithPopoverWithDocs.propTypes = (0, _objectSpread2.default)({}, _sharedPropTypes.sharedPropTypes, {
  shouldFocusTriggerOnClose: _stencilReactDesc.PropTypes.bool.description('Whether focus should be returned to the trigger element when the popover closes.')
});
var _default = WithPopoverWithDocs;
exports.default = _default;